import { render, staticRenderFns } from "./PresenceRanking.vue?vue&type=template&id=32cae61d&scoped=true&lang=pug"
import script from "./PresenceRanking.vue?vue&type=script&lang=js"
export * from "./PresenceRanking.vue?vue&type=script&lang=js"
import style0 from "./PresenceRanking.vue?vue&type=style&index=0&id=32cae61d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cae61d",
  null
  
)

export default component.exports